
import { Component, Prop, Vue } from 'vue-property-decorator';
import BasePaginatorHoc from '@/components/base/BasePaginatorHoc.vue';
import ExportResourceStatusList from './exportResourceStatusList.vue';
import { mixins } from 'vue-class-component';
import { PaginationMixin } from '@/components/base/pagination.mixin';
import { WkExportResourceDetail } from '../../jbi-shared/types/wk-export.types';

@Component({
  components: { BasePaginatorHoc }
})
export default class PaginateWkExportResouceList extends mixins(
  PaginationMixin
) {
  @Prop() public items!: WkExportResourceDetail[];
  @Prop() public totalCount!: number;
  @Prop() public sortCriteria!: string;
  @Prop() public sortOrder!: 'ASC' | 'DESC';
  @Prop() public selectable!: boolean;
  @Prop() public pagination!: boolean;

  get ExportStatusList() {
    return ExportResourceStatusList;
  }
}
